import Partner from "../../../classes/Partner";
import * as React from "react";
import AppContext from "../AppContext";
import Section from "../Section/Section";
import { _t } from "../../../utils/Translator";
import Invoice from "../../../classes/Invoice";
import api from "../../api";

type SectionInvoicesProps = {
  partner: Partner;
  canCreatePartner: boolean;
};

type SectionInvoicesState = {
  invoices: Invoice[];
};

class SectionInvoices extends React.Component<SectionInvoicesProps, SectionInvoicesState> {
  constructor(props, context) {
    super(props, context);
    const invoices = this.props.partner.invoices;
    this.state = { invoices: invoices };
  }

  private getInvoiceDescription = invoice => {
    return invoice.amount_total + " " + invoice.currency_id[1];
  };

  render() {
    return (
      <Section
        records={this.state.invoices}
        partner={this.props.partner}
        canCreatePartner={this.props.canCreatePartner}
        model="account.move"
        odooEndpointCreateRecord={api.createInvoice}
        odooRecordIdName="invoice_id"
        odooRedirectAction="helpdesk_mail_plugin.helpdesk_ticket_action_form_edit"
        title="Invoices"
        titleCount="Invoices (%(count)s)"
        msgNoPartner="Save Contact to create new Invoices.."
        msgNoPartnerNoAccess="The Contact needs to exist to create Invoices."
        msgNoRecord="No invoices found for this contact."
        msgLogEmail="Log Email Into Invoice"
        getRecordDescription={this.getInvoiceDescription}
      />
    );
  }
}
SectionInvoices.contextType = AppContext;
export default SectionInvoices;
